import '../util/aria.js';
import { LitElement, html, property, customElement } from 'lit-element';
import { cssResult } from '../util/css.js';
import { renderAttributes } from '../util/dom.js';
import { __decorate, __metadata } from 'tslib';
import { sharedStyles } from '../style/shared.js';
import styles from './title.scss.js';

let Title = class Title extends LitElement {
    constructor() {
        super(...arguments);
        this.level = 1;
        this.nowrap = false;
        this.role = 'heading';
    }
    updated(props) {
        super.updated(props);
        if (props.has('level')) {
            renderAttributes(this, { 'aria-level': this.level });
        }
    }
    render() {
        return html` <slot></slot> `;
    }
};
Title.styles = [
    sharedStyles,
    cssResult(styles)
];
__decorate([
    property({
        type: Number,
        reflect: true
    }),
    __metadata('design:type', Number)
], Title.prototype, 'level', void 0);
__decorate([
    property({ type: Boolean }),
    __metadata('design:type', Boolean)
], Title.prototype, 'nowrap', void 0);
__decorate([
    property({
        type: String,
        reflect: true
    }),
    __metadata('design:type', String)
], Title.prototype, 'role', void 0);
Title = __decorate([customElement('wl-title')], Title);

export { Title };
